module.exports = __webpack_public_path__ + "static/media/menu_strip_background.0e48e943.svg";